// const BASE_URL = 'http://localhost:3000';
const BASE_URL = 'https://automation.appmaker.xyz';
export{
    BASE_URL
}